import { useField } from "formik";

import { TextField, TextFieldProps } from "./TextField";
import {
  InputWrapperProps,
  InputWrapper,
} from "../../../components/inputs/_assets/input-wrapper/InputWrapper";

interface Props<T, K>
  extends Omit<TextFieldProps, "onChange">,
    InputWrapperProps {
  name: string;
  label: string;
  info?: React.ReactNode;
  testID?: string;
  isNullable?: T;
  onChange?: (value: K) => void;
}

/**
 * @deprecated see TextInputFormikField
 */
export function TextInputField<T, K = T extends true ? string | null : string>({
  name,
  span = "auto",
  testID = "text-input",
  isNullable,
  ...props
}: Props<T, K>) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span}>
      <TextField
        validationState={meta.touched && meta.error ? "invalid" : "valid"}
        errors={meta.touched && meta.error}
        {...field}
        {...props}
        onChange={(param) => {
          const value = (isNullable && param === "" ? null : param) as K;
          helpers.setValue(value);
          props.onChange && props.onChange(value);
        }}
        testID={testID}
      />
    </InputWrapper>
  );
}
